// eslint-disable-next-line no-unused-vars
import { IForgotForm } from '../../../../../TypeScript/Interfaces/IForgotForm';

export default {
  Email: '',
} as IForgotForm;
